export const ISOMaskedRegex =
  /(\d{4}|\*{4})(\/|-)([01]\d|\*{2})(\/|-)([0-3]\d|\*{2})/;

export const parseFromMaskedISO = (value: string): string => {
  const normalizedValue = normalizeDelimiter(value, '-');
  const d = normalizedValue.split('-'); // [YYYY, MM, DD]
  return `${d[1]}/${d[2]}/${d[0]}`; // MM/DD/YYYY
};

const normalizeDelimiter = (value: string, delimiter: string): string => {
  return value.replace(/\/|-/g, delimiter);
};

export const formatPhoneNumber = (value: string) => {
  const digits = Array.from(value).filter((char) => /\d/.test(char));

  return [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 10)]
    .filter((chunk) => chunk.length > 0)
    .map((chunk) => chunk.join(''))
    .join('-');
};

export const formatPrice = (value: number, decimals: number = 2): string => {
  const d = Number.isFinite(decimals)
    ? Math.max(0, Math.min(20, Math.trunc(decimals)))
    : 2;

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: d,
    maximumFractionDigits: d,
  });

  return formatter.format(value);
};

// Fees can be fractional (e.g. the $2.50 weekly installment fee); show cents only
// when needed so whole-dollar fees stay clean and fractional ones aren't rounded
// (formatPrice(x, 0) renders $2.50 as "$3").
export const formatFeeAmount = (amount: number): string =>
  formatPrice(amount, amount % 1 === 0 ? 0 : 2);
